/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __extends } from "tslib";
import * as Models from "./models";
import * as Mappers from "./models/mappers";
import * as operations from "./operations";
import { FaceClientContext } from "./faceClientContext";

var FaceClient =
/** @class */
function (_super) {
  __extends(FaceClient, _super);
  /**
   * Initializes a new instance of the FaceClient class.
   * @param endpoint Supported Cognitive Services endpoints (protocol and hostname, for example:
   * https://westus.api.cognitive.microsoft.com).
   * @param credentials Subscription credentials which uniquely identify client subscription.
   * @param [options] The parameter options
   */


  function FaceClient(credentials, endpoint, options) {
    var _this = _super.call(this, credentials, endpoint, options) || this;

    _this.face = new operations.Face(_this);
    _this.personGroupPerson = new operations.PersonGroupPerson(_this);
    _this.personGroup = new operations.PersonGroupOperations(_this);
    _this.faceList = new operations.FaceListOperations(_this);
    _this.largePersonGroupPerson = new operations.LargePersonGroupPerson(_this);
    _this.largePersonGroup = new operations.LargePersonGroupOperations(_this);
    _this.largeFaceList = new operations.LargeFaceListOperations(_this);
    _this.snapshot = new operations.SnapshotOperations(_this);
    return _this;
  }

  return FaceClient;
}(FaceClientContext); // Operation Specifications


export { FaceClient, FaceClientContext, Models as FaceModels, Mappers as FaceMappers };
export * from "./operations";